<template>
  <b-modal
    id="delete-category-modal"
    title="Delete Category"
    hide-footer
  >
    <h4 class="mb-2">
      Are you sure you want to delete {{ name }}?
    </h4>
    <b-button
      variant="danger"
      block
      :disabled="deletingCategory"
      @click="deleteCategory"
    >
      <b-spinner
        v-if="deletingCategory"
        small
      />
      <span v-else>Delete Category</span>
    </b-button>
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const name = computed(() => props.category?.name?.en || '')

    const deletingCategory = ref(false)
    const deleteCategory = async () => {
      try {
        deletingCategory.value = true
        await ctx.root.$store.dispatch('business/deleteCategory', {
          catId: props.category.id,
          payload: {
            businessId,
            hardDelete: true,
          },
        })
        ctx.root.$bvModal.hide('delete-category-modal')
        ctx.emit('category-deleted')
      } finally {
        deletingCategory.value = false
      }
    }
    return {
      name,
      deleteCategory,
      deletingCategory,
    }
  },
}
</script>

<style>

</style>
